import { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shadcnComponents/ui/table";
import { Button } from "@/shadcnComponents/ui/button";
import { getDate } from "./AdminUtils";

export const AdminBrandTable = ({ allBrands, handleBrandClick }) => {
  const [filteredBrands, setFilteredBrands] = useState(allBrands);
  const [filters, setFilters] = useState({
    joinedDate: "",
    minChips: "",
  });
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc",
  });

  useEffect(() => {
    // Apply filters and sorting
    let brands = allBrands;

    if (filters.joinedDate) {
      brands = brands.filter((brand) =>
        brand.createdAt
          ? getDate(brand.createdAt).includes(filters.joinedDate)
          : false
      );
    }

    if (filters.minChips) {
      brands = brands.filter(
        (brand) =>
          brand.total_credits &&
          Number(brand.total_credits) >= Number(filters.minChips)
      );
    }

    if (sortConfig.key) {
      brands.sort((a, b) => {
        let aValue = a[sortConfig.key];
        let bValue = b[sortConfig.key];

        // Convert values to numbers if sorting by 'total_credits' (Chips)
        if (sortConfig.key === "total_credits") {
          aValue = parseInt(aValue) || 0; // Default to 0 if the value is null or undefined
          bValue = parseInt(bValue) || 0;
          return (aValue - bValue) * (sortConfig.direction === "asc" ? 1 : -1);
        } else {
          // Handle as string for other fields
          const order = sortConfig.direction === "asc" ? 1 : -1;
          return (
            (aValue || "").toString().localeCompare((bValue || "").toString()) *
            order
          );
        }
      });
    }

    setFilteredBrands(brands);
  }, [allBrands, filters, sortConfig]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const toggleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const exportBrandsToCSV = () => {
    const headers = [
      "S. No.,Name,Email,Phone,PocName,Source,Joined Date,Chips",
    ];
    const rows = filteredBrands?.map(
      (item, index) =>
        `${index + 1},"${item?.name || ""}","${item?.email || ""}","${
          item?.companyPhoneNumber || ""
        }","${item?.PocName || ""}","${item?.JoinedFrom || ""}","${
          getDate(item?.createdAt) || ""
        }","${item?.total_credits || ""}"`
    );

    const csvData = headers.concat(rows).join("\n");
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "brands_data.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <div className="flex space-x-4 mb-4">
        <input
          type="text"
          name="joinedDate"
          placeholder="Filter by Joined Date (YYYY-MM-DD)"
          value={filters.joinedDate}
          onChange={handleFilterChange}
          className="border rounded px-2 py-1"
        />
        <input
          type="number"
          name="minChips"
          placeholder="Minimum Chips"
          value={filters.minChips}
          onChange={handleFilterChange}
          className="border rounded px-2 py-1"
        />
        <Button
          onClick={exportBrandsToCSV}
          className="bg-blue-500 text-white rounded-md shadow-md px-4 py-2 hover:bg-blue-600 transition duration-150"
        >
          Export to CSV
        </Button>
      </div>

      <Table className="min-w-[360px] w-full overflow-auto ">
        <TableHeader className="sticky top-0 bg-[#1e1e1e] z-10">
          <TableRow className="bg-[#1e1e1e] hover:bg-[#1e1e1e] hover:rounded-lg border-b border-[#262626]">
            <TableHead className="min-w-[80px] text-center">S. No.</TableHead>
            <TableHead
              className="text-start cursor-pointer"
              onClick={() => toggleSort("name")}
            >
              Name
            </TableHead>
            <TableHead className="text-start">Email</TableHead>
            <TableHead className="text-start">Phone</TableHead>
            <TableHead
              className="text-start cursor-pointer"
              onClick={() => toggleSort("PocName")}
            >
              PocName
            </TableHead>
            <TableHead className="text-start">Source</TableHead>
            <TableHead className="text-start">Joined Date</TableHead>
            <TableHead
              className="text-start cursor-pointer"
              onClick={() => toggleSort("total_credits")}
            >
              Chips
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {filteredBrands?.map((item, index) => (
            <TableRow key={item._id} className="border-b border-[#262626]">
              <TableCell className="text-center">{index + 1}</TableCell>
              <TableCell
                onClick={() => handleBrandClick(item?._id, item?.status)}
                className="flex justify-start max-w-[200px] overflow-hidden text-wrap items-center space-x-2 text-start cursor-pointer"
              >
                <span>{item?.name}</span>
              </TableCell>
              <TableCell className="text-start">{item?.email}</TableCell>
              <TableCell className="text-start">
                {item?.companyPhoneNumber}
              </TableCell>
              <TableCell className="text-start">{item?.PocName}</TableCell>
              <TableCell className="text-start">{item?.JoinedFrom}</TableCell>
              <TableCell className="text-start">
                {getDate(item?.createdAt)}
              </TableCell>
              <TableCell className="text-start">
                {item?.total_credits}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
};
